import store from '../store/store'
import cache from './cache'

export function checkPermission(value) {

	let admin = this.$store.getters['admin/user'];

	let permissions = admin.permissions;
	if (!permissions || permissions.length == 0) {

		return false;
	}

	if (permissions.indexOf(value) == -1) {
		return false;
	}

	return true;
}

export function getUserDengji(user) {
	let info = { name: '注册用户', zhekou: 100 };

	if (user.totalpoint >= 5000) {
		info.name = '钻石会员';
		info.zhekou = 75;
		return info;
	}

	if (user.totalpoint >= 3000) {
		info.name = '铂金会员';
		info.zhekou = 80;
		return info;
	}
	if (user.totalpoint >= 1000) {
		info.name = '金卡会员';
		info.zhekou = 85;
		return info;
	}
	if (user.totalpoint >= 500) {
		info.name = '银卡会员';
		info.zhekou = 90;
		return info;
	}
	if (user.totalpoint >= 200) {
		info.name = '铜卡会员';
		info.zhekou = 95;
		return info;
	}

	return info;
}

export function checkSession() {
	let time = (new Date()).getTime();
	let lastTime = cache.get('last_click_time');
	if (lastTime) {
		lastTime = Number(lastTime);
		if (lastTime < time - (24 * 60 * 60 * 1000)) {
			// 已经过期
			return true;
		}
	}
	cache.set('last_click_time', time);
	return false;
}
/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate 是否立即执行
 * @return {*}
 */
export function debounce(func, wait = 1500, immediate = true) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}


// WEBPACK FOOTER //
// ./src/util/index.js